import {
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    NativeSelect,
    useTheme,
  } from "@mui/material";
  import { Formik } from "formik";
  import * as yup from "yup";
  import useMediaQuery from "@mui/material/useMediaQuery";
  import Header from "../Components/Header";
  import { Link, useNavigate } from "react-router-dom";
  import axios from "axios";
  import { ToastContainer, toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { tokens } from "../theme";
  import KeyboardReturnOutlinedIcon from "@mui/icons-material/KeyboardReturnOutlined";
  import { useEffect, useState } from "react";
  import * as React from "react";
  import Radio from "@mui/material/Radio";
  import RadioGroup from "@mui/material/RadioGroup";
  import FormControlLabel from "@mui/material/FormControlLabel";
import baseURL from "../config";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

  
  const Form = () => {
    const theme = useTheme();
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const isTablet = useMediaQuery("(min-width:1175px");
    const colors = tokens(theme.palette.mode);

    const [advocates, setAdvocates] = useState([]);
    const navigate = useNavigate();
    // const [isFeeActive, setIsFeeActive] = useState(true);
    // const [clientStatus, setClientStatus] = useState(true)
  
    // const handleStatusChange = (event) =>{
    //   setClientStatus(event.target.value == "true");
    // }
    // const handleRadioChange = (event) => {
    //   setIsFeeActive(event.target.value === "true");
    // };
  
    const handleFormSubmit = async (values, actions) => {
      if(values.Email == ""){
        toast.error("Plotesoni te dhenat")
        console.log("error");
        
      }
      try {
        await axios.post( `${baseURL}/api/User/Register`,{
            userId: 40,
            password: values.Password,
            email: values.Email,
            phoneNumber: values.PhoneNumber,
            address: values.Address,
            state: values.State || "string", 
            role: values.Role || "string",
            gender: values.Gender || "string",
            birthdate: values.Birthdate || "string",
            message: values.Message || "string",
            name: values.Name || "string",
            surname: values.Surname || "string",
            success: values.Success || true,
            loyaltyCardNumber: values.LoyaltyCardNumber || "string",
        });
        navigate("/clients");
      } catch (error) {
        if (error.response) {
    
          actions.resetForm();
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      }
    };
    const style = {
      radiobutton: {
        float: "right",
      },
    };
  
    return (
      <Box m="20px">
        <ToastContainer hideProgressBar={true} autoClose={2000} />
        <Header title="Shto User" subtitle="Plotesoni te dhenat per user" />
        <Link to="/clients" style={{ textDecoration: "none" }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: colors.primary[700], marginBottom: 2 }}
          >
            <KeyboardReturnOutlinedIcon />
            Tabela e users
          </Button>
        </Link>
  
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setValues,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Name}
                  name="Name"
                  error={!!touched.Name && !!errors.Name}
                  helperText={touched.Name && errors.Name}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Surname"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Surname}
                  name="Surname"
                  error={!!touched.Surname && !!errors.Surname}
                  helperText={touched.Surname && errors.Surname}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Email}
                  name="Email"
                  error={!!touched.Email && !!errors.Email}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Phone Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.PhoneNumber}
                  name="PhoneNumber"
                  error={!!touched.PhoneNumber && !!errors.PhoneNumber}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Gender"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Gender}
                  name="Gender"
                  error={!!touched.Gender && !!errors.Gender}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Role"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Role}
                  name="Role"
                  error={!!touched.Role && !!errors.Role}
                  sx={{ gridColumn: "span 1" }}
                />
  
                {/* <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Birthdate"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Birthdate}
                  name="Birthdate"
                  error={!!touched.Birthdate && !!errors.Birthdate}
                  sx={{ gridColumn: "span 1" }}
                /> */}
                 <LocalizationProvider dateAdapter={AdapterDayjs}>
             <DateTimePicker
              label="Birthdate"
              value={values.Birthdate || null}
              sx={{ gridColumn: "span 2" }}
              onChange={(newValue) => setFieldValue("Birthdate", newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  variant="filled"
                  name="StartDate"
                  error={!!touched.StartDate && !!errors.StartDate}
                  helperText={touched.StartDate && errors.StartDate}
                />
              )}
            />

              </LocalizationProvider>
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Address}
                  name="Address"
                  error={!!touched.Address && !!errors.Address}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.Password}
                  name="Password"
                  error={!!touched.Password && !!errors.Password}
                  sx={{ gridColumn: "span 1" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="State"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.State}
                  name="State"
                  error={!!touched.State && !!errors.State}
                  sx={{ gridColumn: "span 1" }}
                />
                <Box sx={{ gridColumn: "span 4" }}>
                  {" "}
                  <hr
                    style={{
                      border: "none",
                      height: "2px",
                      backgroundColor: "white",
                      margin: "0",
                      padding: "0",
                    }}
                  />
                </Box>
               
  
             
             
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button type="submit" style={{ backgroundColor: colors.primary[700]}} variant="contained">
                Shto user
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    );
  };
  
  
  const checkoutSchema = yup.object().shape({
    Name: yup.string().required("Name is required"),
    Surname: yup.string().required("Surname is required"),
    Email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    PhoneNumber: yup
      .string()
      .matches(/^\d+$/, "Phone number must be numeric")
      .required("Phone number is required"),
    Gender: yup.string().required("Gender is required"),
    Role: yup.string().required("Role is required"),
    Birthdate: yup.date().required("Birthdate is required"),
    Address: yup.string().required("Address is required"),
    Password: yup.string().required("Password is required"),
    State: yup.string().required("State is required"),
  });
  const initialValues = {
    Name: "",
    Surname: "",
    Email: "",
    PhoneNumber: "",
    Gender: "",
    Role: "",
    Birthdate: null,
    Address: "",
    Password: "",
    State: "",
    Message: "",
    LoyaltyCardNumber: "",
  };
  
  export default Form;